"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var api_request_1 = require("../../api_request");
var lodash_1 = require("lodash");
var callout_embed_1 = require("../callout_embed");
var HandpickedCalloutEmbed = /** @class */ (function (_super) {
    tslib_1.__extends(HandpickedCalloutEmbed, _super);
    function HandpickedCalloutEmbed(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            name: null,
            href: null,
            image: null,
        };
        return _this;
    }
    HandpickedCalloutEmbed.prototype.componentDidMount = function () {
        var _this = this;
        var req = api_request_1.V3.get("/api/curated_sets/" + this.props.slug + "/collection_header");
        req.then(function (response) {
            _this.setState({
                name: response.title,
                href: lodash_1.get(response, '_links.web.href'),
                image: lodash_1.get(response, '_links.full_bleed_header_image.href'),
            });
        });
    };
    HandpickedCalloutEmbed.prototype.render = function () {
        if (!this.state.href) {
            return null;
        }
        return (React.createElement(callout_embed_1.default, { title: this.state.name, href: this.state.href, backgroundImage: this.state.image, narrow: this.props.narrow }));
    };
    return HandpickedCalloutEmbed;
}(React.Component));
exports.default = HandpickedCalloutEmbed;
//# sourceMappingURL=handpicked.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/components/embeds/callouts/handpicked.js
// module id = 7HBa
// module chunks = 20 21